import { AfterContentChecked, AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';
// import * as CanvasJS from 'src/assets/canvasjs.min.js';
declare var CanvasJS: any
declare var $: any;
@Component({
  standalone: false,
  selector: 'app-view-patient',
  templateUrl: './view-patient.component.html',
  styleUrls: ['./view-patient.component.css']
})
export class ViewPatientComponent implements OnInit, AfterViewInit {
  tabView: any = 'SessionRequests';
  patientId: any;
  viewPatientData: any;
  therapistId: any;
  assessmentData: any = [];
  sessionListData: any = [];
  viewNotesArr: any = [];
  IsShowNotes: boolean = false;
  panelOpenState = false;
  drinkingDiaryarr: any = [];
  chart: any;
  constructor(private activatedroute: ActivatedRoute, private service: MainService,
    private router: Router) {
    this.activatedroute.queryParams.subscribe((res) => {
      let paitentData = JSON.parse(res.value);
      this.patientId = paitentData.patientId;
      this.therapistId = paitentData.therapistId
    })
    this.viewPatientApi();
  }

  ngOnInit() {
    this.getAssessmentDetailsApi();
    this.getSession_list();
    this.getNotesDetailsApi();
    this.getDrinkingDiarylist();
  }

  ngAfterViewInit() {
    this.viewPatientApi();

  }



  myChart() {
    let dataPoints: any = [];

    this.chart = new CanvasJS.Chart("chartContainer", {
      exportEnabled: true,
      title: {
        text: "Drinking Diary Report"
      },
      // axisX: {
      // 	valueFormatString: "MMM"
      // },
      data: [{
        type: "line",
        xValueFormatString: "DD MMM YYYY",
        // yValueFormatString: "#,##0",
        dataPoints: dataPoints,
      }]
    });
    this.drinkingDiaryarr.forEach((data: any) => {
      dataPoints.push({ label: data.createdDay, y: parseInt(data.achivedGoal) });
    });
    this.chart.render();
  }


  // To get patient details by view patient api integration 

  viewPatientApi() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.viewPatient + `?userId=${this.patientId}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        setTimeout(() => {
          this.viewPatientData = res.userData;
          this.service.hideSpinner();

        }, 1000);
      }
      else {
        this.service.hideSpinner();
      }

    })
  }


  // To get notes details api integration 

  getNotesDetailsApi() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.patient_notes_list + `?patientId=${this.patientId}&therapistId=${this.therapistId}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.IsShowNotes = true;
        this.viewNotesArr = res.result ? res.result : "";
        this.service.hideSpinner();
      }
      else {
        this.viewNotesArr = res.result ? res.result : "";
        this.service.hideSpinner();
      }
    })
  }

  // To getAssessmentDetailsApi api integration 

  getAssessmentDetailsApi() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.patient_assessmentList + `?patientId=${this.patientId}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.assessmentData = res.result ? res.result : "";
        this.service.hideSpinner();
      }
      else {
        this.assessmentData = res.result ? res.result : "";
        this.service.hideSpinner();
      }
    })
  }

  getSession_list() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.patient_sessionList + `?patientId=${this.patientId}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.sessionListData = res.result ? res.result : "";
        this.service.hideSpinner();
      }
      else {
        this.sessionListData = res.result ? res.result : "";
        this.service.hideSpinner();
      }
    })
  }

  getDrinkingDiarylist() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.drinkingDairy_details + `?userId=${this.patientId}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.drinkingDiaryarr = res.result ? res.result : "";
        this.drinkingDiaryarr.map((res: any) => res['createdDay'] = new Date(res.date).toDateString().split(' ')[0]);
        this.service.hideSpinner();
      }
      else {
        this.sessionListData = res.result ? res.result : "";
        this.service.hideSpinner();
      }
    })
  }


  viewTab(tab: any) {
    this.tabView = tab;
    if (this.tabView == 'Drinkingdiary') {
      this.myChart()
    }
    else {
      this.chart = new CanvasJS.Chart("chartContainer", {
      });
    }
  }

  onImageError(event: any) {
    event.target.src = 'https://res.cloudinary.com/smsit/image/upload/v1597335652/fmcvdi2g6ogd5vwzvzfa.jpg';
  }

}
